import { Column } from "@/components/Datatable/types";
import { CertificateDownloadLink } from "@/components/TrainingCertificate/CertificateDownloadLink";
import { TrainingHistoryReportItem } from "../../api/fetchTrainingHistoryReport/types";

export function trainingHistoryReportColumns(): Column<TrainingHistoryReportItem>[] {
  return [
    {
      header: "Company Name",
      accessorKey: "companyName",
      enableSorting: true,
      cell: ({ row }) => row.original.companyName,
    },
    {
      header: "Intacct ID",
      accessorKey: "intacctId",
      cell: ({ row }) => row.original.intacctId ?? "",
    },
    {
      header: "Full Name",
      accessorKey: "fullName",
      enableSorting: true,
      cell: ({ row }) => row.original.fullName,
    },
    {
      header: "Session Dates",
      accessorKey: "sessionStartDate",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionDates,
    },
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Location",
      accessorKey: "locationName",
      enableSorting: true,
      cell: ({ row }) => row.original.location,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row }) => row.original.status,
    },
    {
      header: "Certificate",
      accessorKey: "certificate",
      cell: ({ row }) =>
        row.original.certificate ? (
          <CertificateDownloadLink
            attendeeName={row.original.fullName}
            courseName={row.original.eventName}
            sessionDates={row.original.sessionDates}
          />
        ) : (
          ""
        ),
    },
  ];
}
